export default __webpack_public_path__ + "static/brush-yellow-circle-411717d8fc618f53f07a826da3e7183a.png";